import React from 'react';
import { SimpleInput } from '../../../../../components/shared';

interface IfcInputProps {
  onIfcChange: (value: string) => void;
  ifcValue: string;
  isEnabled: boolean;
}

export const IfcInput: React.FC<IfcInputProps> = ({
  onIfcChange,
  ifcValue,
  isEnabled
}) => {
  return (
    <SimpleInput
      title="IFC"
      label="Enter IFC details:"
      placeholder="Enter International Fire Code information..."
      value={ifcValue}
      onChange={onIfcChange}
      isEnabled={isEnabled}
    />
  );
};
